import React, {useEffect} from "react";
import { Routes, Route } from "react-router-dom";
import InterviewerRequest from "./InterviewerRequest";
import InterviewerAccepted from "./InterviewerAccepted";
import InterviewerUpcoming from "./InterviewerUpcoming";
import InterviewerCompleted from "./InterviewerCompleted";
import InterviewerProfileForm from "./InterviewerProfileForm";
import InterviewerProfileFormOld from "./OldProfileForm";
// import Navbarlogedin from "../Dashboard/Navbarlogedin";
import InterviewerDashboard from "./InterviewerDashboard";
import Myprofile from "./Myprofile";
import Int2Std from "./Int2Std";
import TimePicker from "./TimePreference/TimePicker";
// import Navbarlogedin from "../Dashboard/Navbarlogedin";

function Interviewer() {
  useEffect(() => {
    setTimeout(() => window.scrollTo(0, 0), 100);
  }, []);
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: "rgb(235, 235, 235)",
        height: "auto",
      }}
    >
      <Routes>
        <Route path="request" element={<InterviewerRequest />} />
        <Route path="accepted" element={<InterviewerAccepted />} />
        <Route path="upcoming" element={<InterviewerUpcoming />} />
        <Route path="completed" element={<InterviewerCompleted />} />
        <Route path="profile-form" element={<InterviewerProfileForm />} />
        <Route path="myprofile" element={<Myprofile />} />
        <Route
          path="profile-form-old"
          element={<InterviewerProfileFormOld />}
        />
        <Route path="dashboard" element={<InterviewerDashboard />} />
        <Route path="timepicker" element={<TimePicker />} />
        <Route path="int-std" element={<Int2Std />} />
      </Routes>
    </div>
  );
}

export default Interviewer;
